import React from 'react'
import PropTypes from 'prop-types'
import { WithRouter } from '@/components/WithRouter'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import { assignDedicatedTechnician } from '@/service/orderTypeApis'
import FormData from './DispatcherTechnicianForm'
class DispatcherTechnicianModal extends React.Component {
  state = {
    baseComponent: ''
  }
  static propTypes = {
    baseProps: PropTypes.object,
    title: PropTypes.string,
    width: PropTypes.number,
    onSuccess: PropTypes.func
  }

  handleOk = async (form) => {
    try {
      const { orderId, onSuccess } = this.props
      const fields = await form.current.validateFields()
      const technicianId = fields.technicianId || []
      const nurseId = fields.nurseId || []
      if (technicianId.length === 0 && nurseId.length === 0) {
        throw new Error('请至少选择一位产康师或护理师')
      }
      if (technicianId.length > 0) {
        await assignDedicatedTechnician(orderId, {
          role: 'TECHNICIAN',
          principals: technicianId.join(',')
        })
      }
      if (nurseId.length > 0) {
        await assignDedicatedTechnician(orderId, {
          role: 'NURSE',
          principals: nurseId.join(',')
        })
      }
      message.success('指派成功~!', 5)
      if (typeof onSuccess === 'function') onSuccess()
    } catch (err) {
      throw err
    }
  }

  render () {
    const { children, baseProps, width, title } = this.props
    const baseComponent = <FormData />
    return (
      <WrappedModal
        children={children}
        baseProps={{ ...baseProps }}
        baseComponent={baseComponent}
        title={title}
        width={width}
        onOk={this.handleOk}
      />
    )
  }
}

export default WithRouter(DispatcherTechnicianModal)
